const ENV = process.env.VUE_APP_ENV

export const APPID = 80001
export const ACTIVITYCODE = ENV === 'production' ? '8496185ac82551f6' : 'e05c83d3c6897ce9'
export const CHANNELID = ENV === 'production' ? '14768763' : '14767147'
export const ORDERLIST = ENV === 'production' ? 'https://mobile.vipkid.com.cn/shoporders/list' : 'https://stage-mobile.vipkid-qa.com.cn/shoporders/list'

export default {
  env: ENV,
  appid: APPID,
  activityCode: ACTIVITYCODE,
  channelId: CHANNELID,
  orderList: ORDERLIST
}
